(function () {
  const selectors = {
    drawer: '[data-mglv-cart-drawer]',
    backdrop: '[data-mglv-cart-backdrop]',
    body: '[data-mglv-cart-items]',
    subtotal: '[data-mglv-cart-subtotal]',
    foot: '[data-mglv-cart-foot]',
    checkout: '[data-mglv-cart-checkout]',
    counts: '[data-mglv-cart-count]',
  };

  const state = {
    cart: null,
    loading: false,
  };

  function money(cents) {
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'EUR';
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format((cents || 0) / 100);
  }

  function route(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function elements() {
    return {
      drawer: document.querySelector(selectors.drawer),
      backdrop: document.querySelector(selectors.backdrop),
      body: document.querySelector(selectors.body),
      subtotal: document.querySelector(selectors.subtotal),
      foot: document.querySelector(selectors.foot),
      checkout: document.querySelector(selectors.checkout),
      counts: document.querySelectorAll(selectors.counts),
    };
  }

  function open() {
    const { drawer, backdrop } = elements();
    if (!drawer || !backdrop) return;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (window.mglvSetBodyLock) window.mglvSetBodyLock();
  }

  function close() {
    const { drawer, backdrop } = elements();
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (window.mglvSetBodyLock) window.mglvSetBodyLock();
  }

  function renderItem(item, index) {
    const image = item.image || '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return `
      <div class="mglv-cart-item">
        <div class="mglv-media-frame mglv-cart-item__image">
          ${image ? `<img src="${image}" alt="${escapeHtml(item.product_title)}" width="84" height="84" loading="lazy">` : ''}
        </div>
        <div>
          <div class="mglv-cart-item__top">
            <div>
              <div class="mglv-cart-item__title">${escapeHtml(item.product_title)}</div>
              ${variant ? `<div class="mglv-cart-item__variant">${escapeHtml(variant)}</div>` : ''}
            </div>
            <span class="mglv-cart-item__price">${money(item.final_price || Math.round((item.final_line_price || 0) / Math.max(item.quantity || 1, 1)))}</span>
          </div>
          <div class="mglv-cart-item__controls">
            <div class="mglv-qty">
              <button type="button" data-mglv-cart-qty="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-mglv-cart-qty="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button type="button" class="mglv-cart-remove" data-mglv-cart-qty="${index + 1}" data-qty="0">Remove</button>
          </div>
        </div>
      </div>
    `;
  }

  function render(cart) {
    const { drawer, body, subtotal, foot, checkout, counts } = elements();
    if (!body || !subtotal) return;

    state.cart = cart;
    const hasItems = cart.item_count > 0 && cart.items.length > 0;

    if (drawer) drawer.classList.toggle('is-empty', !hasItems);
    if (foot) foot.hidden = !hasItems;
    if (checkout) {
      checkout.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
      checkout.tabIndex = hasItems ? 0 : -1;
      if (hasItems) {
        checkout.setAttribute('href', route('checkout'));
      } else {
        checkout.removeAttribute('href');
      }
    }

    counts.forEach((count) => {
      count.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
    });
    subtotal.textContent = money(cart.total_price);

    if (!hasItems) {
      body.innerHTML = `
        <div class="mglv-cart-empty">
          <p class="mglv-display" style="font-size:26px;margin-bottom:26px;">Your cart is quiet.</p>
          <a class="mglv-btn-primary mglv-btn-primary--small" href="${route('products/ml1')}">Explore editions</a>
        </div>
      `;
      return;
    }

    body.innerHTML = `<div class="mglv-cart-list">${cart.items.map(renderItem).join('')}</div>`;
  }

  function fetchCart() {
    return fetch(route('cart.js'), { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        render(cart);
        return cart;
      });
  }

  function change(line, quantity) {
    if (state.loading) return;
    state.loading = true;
    fetch(route('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    })
      .then((response) => response.json())
      .then(render)
      .finally(() => { state.loading = false; });
  }

  function add(form) {
    if (state.loading) return Promise.resolve();
    state.loading = true;
    return fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart add failed');
        return fetchCart();
      })
      .then(open)
      .finally(() => { state.loading = false; });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function init() {
    const { drawer, backdrop } = elements();
    if (!drawer || !backdrop) return;

    document.querySelectorAll('[data-mglv-cart-open]').forEach((button) => {
      button.addEventListener('click', () => {
        fetchCart().then(open);
      });
    });

    document.querySelectorAll('[data-mglv-cart-close]').forEach((button) => button.addEventListener('click', close));
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    drawer.addEventListener('click', (event) => {
      const checkout = event.target.closest('[data-mglv-cart-checkout]');
      if (checkout && (!state.cart || state.cart.item_count < 1)) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        return;
      }
    }, true);

    drawer.addEventListener('click', (event) => {
      const target = event.target.closest('[data-mglv-cart-qty]');
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      change(Number(target.dataset.mglvCartQty), Number(target.dataset.qty));
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-mglv-add-form]');
      if (!form) return;
      if (form.dataset.requestOnly === 'true') return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      add(form).catch(() => form.submit());
    });

    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.mglvCart = {
    open,
    close,
    refresh: fetchCart,
    add,
    money,
  };
})();
